/**
 * Inject all effect keyframes CSS into the document head
 * This is called once globally to avoid duplicate injections
 */
export function injectEffectKeyframes() {
  const styleId = 'effect-keyframes-all'

  // Only inject once globally
  if (document.getElementById(styleId)) return

  const style = document.createElement('style')
  style.id = styleId
  style.textContent = `
    @keyframes animatedGradient {
      0%, 100% { background-position: 0% 50%; }
      50% { background-position: 100% 50%; }
    }
    @keyframes animatedGradientMove {
      0% { 
        background-position: 0% 50%;
        transform: rotate(0deg);
      }
      25% { 
        background-position: 100% 50%;
        transform: rotate(90deg);
      }
      50% { 
        background-position: 100% 100%;
        transform: rotate(180deg);
      }
      75% { 
        background-position: 0% 100%;
        transform: rotate(270deg);
      }
      100% { 
        background-position: 0% 50%;
        transform: rotate(360deg);
      }
    }
    @keyframes animatedGradientScale {
      0%, 100% { 
        transform: scale(1) translate(0%, 0%);
      }
      50% { 
        transform: scale(1.5) translate(20%, 20%);
      }
    }
    @keyframes animatedGradientScaleReverse {
      0%, 100% { 
        transform: scale(1.5) translate(0%, 0%);
      }
      50% { 
        transform: scale(1) translate(-20%, -20%);
      }
    }
    @keyframes beamMove {
      0% { background-position: -200% 0; }
      100% { background-position: 200% 0; }
    }
    @keyframes wavyMove {
      0% { background-position: 0 0; }
      100% { background-position: 75px 100px; }
    }
    @keyframes sparkleMove {
      0%, 100% { background-position: 0% 0%; }
      50% { background-position: 100% 100%; }
    }
    @keyframes starTwinkle {
      0%, 100% { opacity: 1; }
      50% { opacity: 0.3; }
    }
    @keyframes meshMove {
      0%, 100% { background-position: 0% 0%; }
      50% { background-position: 100% 100%; }
    }
    @keyframes auroraMove {
      0%, 100% { background-position: 0% 0%; }
      50% { background-position: 100% 100%; }
    }
    @keyframes flickerGrid {
      0%, 100% { opacity: 1; }
      50% { opacity: 0.5; }
    }
    @keyframes meteorMove {
      0% { background-position: 200% 200%; }
      100% { background-position: -100% -100%; }
    }
    @keyframes boxesMove {
      0% { background-position: 0 0, 0 0, 0 0, 0 0; }
      100% { background-position: 100px 100px, 100px 100px, 20px 20px, 20px 20px; }
    }
    @keyframes pathsMove {
      0% { background-position: 0 0, 0 0; }
      100% { background-position: 0 10px, 10px 0; }
    }
    @keyframes fluidMove {
      0%, 100% { background-position: 0% 50%; }
      25% { background-position: 100% 50%; }
      50% { background-position: 100% 100%; }
      75% { background-position: 0% 100%; }
    }
    @keyframes cloudsMove {
      0%, 100% { background-position: 0% 0%; }
      33% { background-position: 100% 0%; }
      66% { background-position: 100% 100%; }
    }
    @keyframes orbsMove {
      0%, 100% { background-position: 0% 50%; }
      50% { background-position: 100% 50%; }
    }
    @keyframes dotMatrixMove {
      0% { background-position: 0 0; }
      100% { background-position: 20px 20px; }
    }
    @keyframes spotlightMove {
      0%, 100% { background-position: 0% 0%; }
      25% { background-position: 100% 0%; }
      50% { background-position: 100% 100%; }
      75% { background-position: 0% 100%; }
    }
    @keyframes rippleMove {
      0% { background-size: 0% 0%; }
      100% { background-size: 200% 200%; }
    }
    @keyframes bubblesFloat {
      0%, 100% { background-position: 0% 100%; }
      50% { background-position: 100% 0%; }
    }
    @keyframes neuralPulse {
      0%, 100% { opacity: 0.3; }
      50% { opacity: 1; }
    }
    @keyframes matrixRain {
      0% { background-position: 0 0; }
      100% { background-position: 0 20px; }
    }
    @keyframes particlesFlow {
      0% { background-position: 0% 0%; }
      100% { background-position: 100% 100%; }
    }
  `
  document.head.appendChild(style)
}
